// "John Smith" -> "Smith, John". Single-word names pass through unchanged.
export const lastFirst = (name) => {
  const parts = (name || "").trim().split(/\s+/);
  if (parts.length < 2) return name || "";
  return `${parts[parts.length - 1]}, ${parts.slice(0, -1).join(" ")}`;
};

// Sort key: last name first, then the rest, case-insensitive.
export const lastNameKey = (name) => {
  const parts = (name || "").trim().split(/\s+/);
  if (parts.length === 0) return "";
  return `${parts[parts.length - 1]} ${parts.slice(0, -1).join(" ")}`.toLowerCase();
};
